export default "__VITE_ASSET__COq828LD__"